// Make constants globally available
window.ON_CHANGE_DEBOUNCE_TIMER = 300;

window.PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Also keep as const for backwards compatibility
const ON_CHANGE_DEBOUNCE_TIMER = window.ON_CHANGE_DEBOUNCE_TIMER;
const PUB_SUB_EVENTS = window.PUB_SUB_EVENTS;